export const defaultItemsPerPage = 20

export const DEFAULT_GROUP_PLOTS_ORDER = 'latest_earliest'

export const MOOD_METER_GROUP_ORDER_KEYS = [
  'latest_earliest',
  'earliest_latest',
  'group_a_z',
  'group_z_a',
] as const

export type MoodMeterGroupOrderKey = (typeof MOOD_METER_GROUP_ORDER_KEYS)[number]

export const MOOD_METER_GROUP_POSTGREST_ORDERS: Record<MoodMeterGroupOrderKey, string> = {
  latest_earliest: 'start_time.desc',
  earliest_latest: 'start_time.asc',
  group_a_z: 'name.asc',
  group_z_a: 'name.desc',
}
